var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formItems),function(item){return _c(_vm.getType(item.field.type),{key:item.key,tag:"component",staticClass:"form-group",attrs:{"field":item.field,"value":_vm.data[item.field.key],"disabled":_vm.disabled},on:{"change":_vm.onChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }